// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAptsusde } from "../../../icons/full/build/icon-aptsusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AptsusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAptsusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AptsusdeIcon.displayName = 'AptsusdeIcon';
}

export default AptsusdeIcon;